<template>
  <div ref="container" class="relative h-full w-full overflow-auto" data-target="container" @contextmenu.prevent>
    <slot />
  </div>
</template>

<script setup>
import { inject, ref, watch } from "vue"

const { element } = inject("CONTAINER_STATE")

const container = ref(null)

watch(
  container,
  container => {
    element.value = container
  },
  { immediate: true }
)
</script>
